module.exports = __webpack_public_path__ + "img/southern-union.f4fda614.jpg";